import { ApplicationRole } from '@/types/application-role';
import { useUser } from './use-user';

export type UseUserRoleReturn = {
  isPlatformAdmin: boolean;
  isOrgAdmin: boolean;
  role: ApplicationRole | undefined;
};

export const useUserRole = (): UseUserRoleReturn => {
  const { user } = useUser();

  // Use numeric ID matching instead of string matching for reliability
  // Platform Admin = 1, Organisation Admin = 2, Care Home User = 3
  const isPlatformAdmin = user.role.id === 1;

  const isOrgAdmin = user.role.id === 2;

  return {
    isPlatformAdmin,
    isOrgAdmin,
    role: user.role,
  };
};
